import { render, staticRenderFns } from "./GeneralView.vue?vue&type=template&id=395e3950&scoped=true&"
import script from "./GeneralView.vue?vue&type=script&lang=js&"
export * from "./GeneralView.vue?vue&type=script&lang=js&"
import style0 from "./GeneralView.vue?vue&type=style&index=0&id=395e3950&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395e3950",
  null
  
)

export default component.exports